import { gql } from 'apollo-boost';

export const deleteRetargetingConditions = gql`
    mutation DeleteRetargetingConditionsMutation(
        $input: GdDeleteRetargetingConditionsInput!
        $login: String!
    ) {
        reqId: getReqId
        deleteRetargetingConditions(input: $input) {
            successCount
            totalCount
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;
